/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaymentData } from './PaymentData';
import {
    PaymentDataFromJSON,
    PaymentDataFromJSONTyped,
    PaymentDataToJSON,
    PaymentDataToJSONTyped,
} from './PaymentData';
import type { ShippingData } from './ShippingData';
import {
    ShippingDataFromJSON,
    ShippingDataFromJSONTyped,
    ShippingDataToJSON,
    ShippingDataToJSONTyped,
} from './ShippingData';
import type { CountryData } from './CountryData';
import {
    CountryDataFromJSON,
    CountryDataFromJSONTyped,
    CountryDataToJSON,
    CountryDataToJSONTyped,
} from './CountryData';

/**
 * 
 * @export
 * @interface DeliveryPaymentsData
 */
export interface DeliveryPaymentsData {
    /**
     * 
     * @type {Array<PaymentData>}
     * @memberof DeliveryPaymentsData
     */
    payments?: Array<PaymentData>;
    /**
     * 
     * @type {Array<ShippingData>}
     * @memberof DeliveryPaymentsData
     */
    shippings?: Array<ShippingData>;
    /**
     * 
     * @type {Array<CountryData>}
     * @memberof DeliveryPaymentsData
     */
    countries?: Array<CountryData>;
}

/**
 * Check if a given object implements the DeliveryPaymentsData interface.
 */
export function instanceOfDeliveryPaymentsData(value: object): value is DeliveryPaymentsData {
    return true;
}

export function DeliveryPaymentsDataFromJSON(json: any): DeliveryPaymentsData {
    return DeliveryPaymentsDataFromJSONTyped(json, false);
}

export function DeliveryPaymentsDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeliveryPaymentsData {
    if (json == null) {
        return json;
    }
    return {
        
        'payments': json['payments'] == null ? undefined : ((json['payments'] as Array<any>).map(PaymentDataFromJSON)),
        'shippings': json['shippings'] == null ? undefined : ((json['shippings'] as Array<any>).map(ShippingDataFromJSON)),
        'countries': json['countries'] == null ? undefined : ((json['countries'] as Array<any>).map(CountryDataFromJSON)),
    };
}

export function DeliveryPaymentsDataToJSON(json: any): DeliveryPaymentsData {
    return DeliveryPaymentsDataToJSONTyped(json, false);
}

export function DeliveryPaymentsDataToJSONTyped(value?: DeliveryPaymentsData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'payments': value['payments'] == null ? undefined : ((value['payments'] as Array<any>).map(PaymentDataToJSON)),
        'shippings': value['shippings'] == null ? undefined : ((value['shippings'] as Array<any>).map(ShippingDataToJSON)),
        'countries': value['countries'] == null ? undefined : ((value['countries'] as Array<any>).map(CountryDataToJSON)),
    };
}

